<template>
  <div class="sliderChart">
    <div v-for="rating in ratingLabels" :key="rating" class="sliderChart__item">
      <div class="sliderChart__label">{{ rating.toFixed(1) }}</div>
      <div class="sliderChart__container">
        <div class="sliderChart__slider" :style="{ '--width': calculatedWidth(rating) }">
          <div v-if="ratingCounts[rating] > 0" class="sliderChart__thumb" :style="{ left: calculatedWidth(rating) }"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    props: {
        ratingCounts: {
            type: Object,
            required: true,
        }
    },
    data() {
        return {
            ratingLabels: [5, 4, 3, 2, 1]
        };
    },
    methods: {
        calculatedWidth(rating) {
            const maxCount = Math.max(...Object.values(this.ratingCounts));
            if (maxCount === 0) {
                return '0%';
            }
            return (this.ratingCounts[rating] / maxCount) * 100 + '%';
        }
    }
};
</script>
